import { Component, OnInit, OnDestroy, ViewChild, Inject, ComponentFactoryResolver } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ServerService } from '../../service/server/server.service';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ModulesComponent } from '../../service/modules/modules.component';
import Num2persian from 'num2persian';
import { WeightDetaileComponent } from '../weight-detaile/weight-detaile.component';


@Component({
  selector: 'app-tip-meter-detaile',
  templateUrl: './tip-meter-detaile.component.html',
  styleUrls: ['./tip-meter-detaile.component.scss']
})
export class TipMeterDetaileComponent implements OnInit, OnDestroy {
  public isOnline: any | undefined;
  public loading = false;
  public subscription: Subscription | undefined;
  public err: string | undefined; public err_validation: boolean = false;
  public err_internet_text: string | undefined; public err_internet_validation: boolean | undefined;
  public server: any = this.serverService.get_server();
  title: string | undefined;
  lang: any = 1;
  cate2: number | undefined;
  list_record: any = [];
  list_record_length = 1;
  user_info: any | undefined;
  user_id: number | undefined;
  search: string;
  cate: number | undefined;
  form1: FormGroup;
  tip: number | undefined;

  public mat_table_hoverRow: any;
  mat_table_selectedRow: any;
  public dataSource: any | undefined;
  displayedColumns = ['row', 'title', 'number', 'operation'];


  constructor(public serverService: ServerService, public router: Router, private matSnackBar: MatSnackBar
    , private matDialogRef: MatDialogRef<TipMeterDetaileComponent>, private dialog: MatDialog
    , @Inject(MAT_DIALOG_DATA) public dialog_data: any) {
    this.cate2 = dialog_data.cate2;
    this.title = dialog_data.title;
    this.tip = dialog_data.tip;
  }//end consructor

  ngOnInit() {
    this.lang = localStorage.getItem('lang');
    this.user_info = JSON.parse(<any>localStorage.getItem("user_info"));
    this.user_id = this.user_info.user_id;
    this.form1 = new FormGroup({
      'amount': new FormControl(null, [Validators.required, Validators.pattern('[0-9]{1,}')]),
      'weight_title': new FormControl(null),
      'weight': new FormControl(null, [Validators.required, Validators.pattern('[0-9]{1,}')])
    })
    this.get_data(1);
  }

  check_access(type_task: number, page: number, id: any, excel: number, loading: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: 222 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.loading = false;
            if (type_task == 3) {
              this.delete(id);
            }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  get_data(type: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 10637, cate2: this.cate2, tip: this.tip }).subscribe(
      (res: any) => {
        this.list_record = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_record.push(res['result'][i]);
          }
          this.dataSource = new MatTableDataSource(this.list_record)
          this.recieve_message(false, "", "", 1, "", "");
        }//end if 
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  insert() {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (!this.form1.valid) {
      return false;
    }
    this.loading = true;
    var obj = {
      address: 10635
      , cate2: this.cate2
      , tip: this.tip
      , weight: this.form1.value.weight
      , amount: this.form1.value.amount
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.list_record.unshift(res['result'][0]);
          this.dataSource.data = this.list_record;
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else if (res['status'] == 4) {
          var pe_message = "این واحد اندازه گیری قبلا اضافه شده است";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  get_bg(row_id: number) {
    //this.row_id = row_id;
  }

  arrowDownEvent() {
    //this.row_id = row_id;
  }

  select(id: number, title: string) {
    this.matDialogRef.close({ id: id, title: title });
  }//end select

  //*******************************************************************************
  delete(id: number) {
    var confirm_delete;
    confirm_delete = window.confirm(this.serverService.message_delete_accept());
    this.loading = false;
    if (confirm_delete == true) {
      this.loading = true;
      var obj = {
        'address': 10640, "user_id": this.user_id, 'id': id
      }
      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res: any) => {
          if (res['status'] == 1) {
            this.list_record.splice(this.list_record.findIndex((index: any) => index.meter_cate2_id == id), 1);
            this.dataSource.data = this.list_record;
            this.recieve_message(false, "", "", 1, "", "");
          }//end if
          else {
            var pe_message = "خطا در حذف";
            var pe_action = "بستن";
            this.recieve_message(true, 'You can only default to one option', pe_message, 1, 'close', pe_action);
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true    
  }//end delete



  load_services(id: number) {
    var where = "";
    var code_id;
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id }
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          if (id == 218) {
            this.form1.patchValue({
              'weight': res.id,
              'weight_title': res.title
            })
          }
        }
      }
    )
  }

  open_detaile(i: number, id: number, title: string) {
    const dialogRef = this.dialog.open(WeightDetaileComponent, {
      width: '25rem',
      height: 'auto',
      disableClose: true,
      data: { type_task: 2, id: id, i: i, cate2: this.cate2, tip: this.tip }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.list_record[i].wharehouse_weight_title = res.wharehouse_weight_title;
          this.list_record[i].meter_cate2_amount = res.meter_cate2_amount;
        }
      }
    )
  }


  reset_input(id: number) {
    if (id == 218) {
      this.form1.patchValue({
        'weight': null,
        'weight_title': null
      })
    }
  }


  close() {
    this.matDialogRef.close({ count: this.list_record.length });
  }

  //**************************************************
  recieve_message(validation: boolean, en_message: string, pe_message: string, type: number, en_action: string, pe_action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      if (this.lang == 1) this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
      if (this.lang == 2) this.matSnackBar.open(en_message, en_action, { duration: 2000 });
    }//end if
    else {
      this.matSnackBar.dismiss();
    }
  }

  message(validation: boolean, message: string, type: number, action: string) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 5000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}